import { lastValueFrom } from 'rxjs';
import { UserVisualConfiguration } from '@app/shared/interfaces/configuracion-visual/config-visual';
import { AuthService } from './../autenticacion/auth..service';
import { Injectable } from '@angular/core';
import { ConfiguracionVisualService } from '../configuracion-visual/configuracion-visual';



@Injectable({
  providedIn: 'root'
})
export class ChangeThemeService {



  currentTheme: string = 'light-theme';

  userConfiguration: UserVisualConfiguration | null = null;




  tipoGrafia: any[] = [
    { nomTipoGrafia: 'Arial, Helvetica, sans-serif', idTipografia: 1 },
    { nomTipoGrafia: "Gill Sans, Gill Sans MT, Calibri, Trebuchet MS, sans-serif", idTipografia: 2 },
    { nomTipoGrafia: "Georgia, Times New Roman, Times, serif", idTipografia: 3 },
    { nomTipoGrafia: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif", idTipografia: 4 },
    { nomTipoGrafia: "Trebuchet MS, Lucida Sans Unicode, Lucida Grande, Lucida Sans, Arial, sans-serif", idTipografia: 5 },
    { nomTipoGrafia: "Verdana, Geneva, Tahoma, sans-serif", idTipografia: 6 },
    { nomTipoGrafia: "Mulish , Mulish-Bold, Mulish-ExtraBold", idTipografia: 7 }
  ];

  //Arreglo que contiene los nombres de los colores con los colores 01, 03 y 05 respectivamente
  themeNames = [
    { nomPaleta: 'blue-corporative', colores: ["#0971CE", "#143859", "#7E57C6", '#A4CEF3'] },
    { nomPaleta: 'red', colores: ['#EB1D1D', '#680D0E', '#F06161', '#F28D8C'] },
    { nomPaleta: 'redish-blue', colores: ['#0779B1', '#0D3A50', '#BE2040', '#A3D3EA', '#'] },
    { nomPaleta: 'red-violet', colores: ['#E33B2D', '#551F13', '#633493', '#F2AD9D'] },
    { nomPaleta: 'bluesh-red', colores: ['#E32D2E', '#551011', '#02AFF0', '#F8ACAC'] },
    { nomPaleta: 'bluesh-green', colores: ['#28BA9E', '#0D4B3F', '#09B3D1', '#97DDCF'] },
    { nomPaleta: 'blue', colores: ['#1F7EDD', '#0D4568', '#61AEF0', '#8CCBF2'] },
    { nomPaleta: 'bluesh-green-invert', colores: ['#09B3D1', '#0D4B3F', '#28BA9E', '#8DD8E5'] },
    { nomPaleta: 'curuba-blue', colores: ['#1F41BA', '#0F1D52', '#EBAD54', '#AFD7FA'] },
    { nomPaleta: 'purple', colores: ['#7a1dd7', '#450D68', '#B361F0', '#CB8CF2'] },
    { nomPaleta: 'yellowish-purple', colores: ['#9E45C7', '#3E1153', '#E9BC00', '#DBADF0'] },
    { nomPaleta: 'blues-purple', colores: ['#AD4DA8', '#52104E', '#3682B9', '#D9A7D6'] },
    { nomPaleta: 'dark-blue-purple', colores: ['#3e5a7b', '#193d6c', '#47718f', '#9dacbe'] },
    { nomPaleta: 'pink', colores: ['#DD1FB1', '#680D4C', '#F061D5', '#F28CCB'] },
    { nomPaleta: 'blues-pink', colores: ['#E54F9B', '#67143E', '#5B75F3', '#F5B5D5'] },
    { nomPaleta: 'pink-violet', colores: ['#EA3666', '#5C1123', '#9D5BD5', '#F2ABBB'] },
    { nomPaleta: 'orange', colores: ['#EB741D', '#68340D', '#F09261', '#F2B38C'] },
    { nomPaleta: 'navy-orange', colores: ['#DE6600', '#532F10', '#007A7A', '#F0C198'] },
    { nomPaleta: 'yellowish-orange', colores: ['#DD821B', '#72440E', '#F4C00E', '#EFC89C'] },
    { nomPaleta: 'yellow', colores: ['#EBCB1D', '#68530D', '#F0CF61', '#F2DE8C'] },
    { nomPaleta: 'greenish-yellow', colores: ['#E2A300', '#5C4816', '#53B27E', '#EDD596'] },
    { nomPaleta: 'bluesh-yellow', colores: ['#F8C000', '#695616', '#01A0E1', '#EFD47A'] },
    { nomPaleta: 'green', colores: ['#1FDD61', '#17680D', '#61F061', '#94F28C'] },
    { nomPaleta: 'orange-green', colores: ['#3EB940', '#125214', '#EFA229', '#A5E8A7'] },
    { nomPaleta: 'gray-blue', colores: ['#007B7B', '#004545', '#a3a1a1', '#80B2B2'] },
  ];


  constructor(private authsvc: AuthService, private configVisualService: ConfiguracionVisualService) {
  }


  setConfigurationThemeUser(config: UserVisualConfiguration) {
    this.userConfiguration = config;
  }

  readUserConfiguration(): UserVisualConfiguration | null {
    return this.userConfiguration;
  }


  //Este servicio deberia solo consultar su tema



  async consultUserTheme() {
    const defaultTheme = 'bluesh-green';
    const defaultFont = this.tipoGrafia[6].nomTipoGrafia;

    try {
      let config = this.readUserConfiguration();
      if (!config) {
        let r = await lastValueFrom(this.configVisualService.getConfiguracionVisual());
        if (r) {
          this.setConfigurationThemeUser(r)
        }

      }
      this.setVisualConfig();

    } catch {
      this.cambiarTema(defaultTheme);
      this.cambiarFuente(defaultFont);
    }
  }

  setVisualConfig() {

    const defaultTheme = 'bluesh-green';
    const defaultThemeTabAdmin = 'bluesh-green';
    const defaultFont = this.tipoGrafia[6].nomTipoGrafia;

    let url = window.location.href;
    this.updateFavicon(null);

    let config = this.readUserConfiguration();
    if (config) {
      const color = config.colorPalette || defaultTheme;
      this.cambiarTema(color);
      let faviconBase64 = sessionStorage.getItem('logoFavicon');
      this.updateFavicon(faviconBase64 || null);
      const typography = config.typography || null
      this.cambiarFuente(typography || defaultFont);
    } else {
      this.cambiarTema(defaultThemeTabAdmin)
      this.cambiarFuente(defaultFont)
    }
  }


  /* Actualiza el favicon de la aplicación, si no la trae desde bd pone el icono por defecto de la carpeta assets*/
  updateFavicon(base64Favicon: string | null) {
    if (base64Favicon === null) {
      this.resetFavicon();
      return;
    }
    const faviconUrl = base64Favicon ? this.base64ToUrl(base64Favicon, 'image/png') : '../../../../assets/images/logos/Logo favicon color.png';
    let faviconElement = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!faviconElement) {
      faviconElement = document.createElement("link");
      faviconElement.rel = "icon";
      document.head.appendChild(faviconElement);
    }
    faviconElement.href = faviconUrl;
  }


  /**
  * Restablece el favicon de la aplicación al logo por defecto.
  *
  * Si no existe un elemento <link rel="icon"> en el <head>, lo crea.
  * Luego asigna al favicon la ruta del logo predeterminado.
  */
  resetFavicon() {
    let faviconElement = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!faviconElement) {
      faviconElement = document.createElement("link");
      faviconElement.rel = "icon";
      document.head.appendChild(faviconElement);
    }
    faviconElement.href = '../../../../assets/images/logos/Logo favicon color.png';
  }




  cambiarTema(theme: string) {
    document.body.classList.remove(...Array.from(document.body.classList));
    document.body.classList.add(`${theme}-theme`);
  }
  getColorPrimarySecundarytertiary(theme: string): any[] {
    let item = this.themeNames.find(name => name.nomPaleta == theme);
    if (item) {
      return item.colores;
    }
    return []
  }

  cambiarFuente(value: string) {
    setTimeout(() => {
      document.body.style.setProperty('--fuente', value);
    }, 100);
  }

  // Convierte una cadena en base64 a una URL
  base64ToUrl(base64: string, contentType: string): string {
    return `data:${contentType};base64,${base64}`;
  }




}
